import type { Distance, Rectangle, SpatialRectangle } from "@pdfking/math"
import { Scale, Subtract, Total } from "@pdfking/math"

import { PageMetrics } from "./PageMetrics"
import { PlateBox } from "./PlateBox"

// The plate a page in `box` shows its poster on: centered in the page, as
// much room over it as under it for a title and a caption, and within the
// margin, the shape of `page`, the book's own, the box's unless told. The
// imposition's name guide is laid out on it
export const PosterBox = (
  box: SpatialRectangle<Distance>,
  page: Rectangle<Distance> = box
): SpatialRectangle<Distance> => {
  const { margin, short } = PageMetrics(box)
  const room = Total(margin, Scale(short, 0.18))
  return PlateBox({
    bottom: Total(box.y, room),
    center: Total(box.x, Scale(box.width, 0.5)),
    max_width: Subtract(box.width, Scale(margin, 2)),
    ratio: page.width / page.height,
    top: Subtract(Total(box.y, box.height), room),
  })
}
